import { render, staticRenderFns } from "./RegulationsDetailView.vue?vue&type=template&id=e2141a8c&scoped=true&"
import script from "./RegulationsDetailView.vue?vue&type=script&lang=ts&"
export * from "./RegulationsDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2141a8c",
  null
  
)

export default component.exports